export * as URI from './schema/uri.js'
export * as Link from './schema/link.js'
export * as Principal from './schema/principal.js'
export * as DID from './schema/did.js'
export * as Text from './schema/text.js'
export * from './schema/schema.js'
export { match as link } from './schema/link.js'
export { match as principal } from './schema/principal.js'
export { match as did, matchBytes as didBytes } from './schema/did.js'
export { match as uri } from './schema/uri.js'
export { match as text } from './schema/text.js'
